module.exports = __webpack_public_path__ + "img/yz_112m_6s2_30min.prt.25b338c5.jpg";